import React from 'react';
import { styled, Button } from '@teko/ui';
import { FormattedTime } from '../../../FormattedTime/FormattedTime.es.js';
import { RatingStars } from '../RatingStars/RatingStars.es.js';

const RateItem = styled.div`
  display: flex;
  padding: 24px;
`;
const UserInfo = styled.div`
  display: flex;
  width: 25%;
`;
const CustomerName = styled.div`
  font-size: 1rem;
  font-weight: 500;
`;
const RatingTime = styled.div`
  color: #848788;
`;
const ReviewContent = styled.div`
  line-height: 20px;
  width: 75%;
`;
const StyledButtonIcon = styled(Button)`
  width: 80px;
  .title {
    font-size: 12px;
  }
`;
const Divider = styled.hr`
  width: 90%;
  margin: 0 auto;
`;
const ReviewLine = ({
  avatar,
  userName,
  title,
  comment,
  rating,
  time
}) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(RateItem, null, /* @__PURE__ */ React.createElement(UserInfo, null, !avatar ? /* @__PURE__ */ React.createElement(StyledButtonIcon, {
    icon: { name: "account", size: 32 },
    link: true
  }) : /* @__PURE__ */ React.createElement("img", {
    src: avatar,
    alt: "avatar"
  }), /* @__PURE__ */ React.createElement("div", {
    className: "ml8"
  }, /* @__PURE__ */ React.createElement(CustomerName, null, userName), time && /* @__PURE__ */ React.createElement(RatingTime, null, /* @__PURE__ */ React.createElement(FormattedTime, {
    time: { dateTime: time, timeFormat: "dd/MM/yyyy HH:mm:ss" }
  })))), /* @__PURE__ */ React.createElement(ReviewContent, null, /* @__PURE__ */ React.createElement(RatingStars, {
    stars: rating,
    readOnly: true
  }), /* @__PURE__ */ React.createElement("div", null, title), /* @__PURE__ */ React.createElement("div", null, comment))), /* @__PURE__ */ React.createElement(Divider, null));
};

export { ReviewLine };
